import styled, { css } from "styled-components";
import { color, typeStyle, variant, visuallyHidden } from "@m/alchemy-theme";
import { HelpPopover as HP } from "../../help-popover/HelpPopover";
export const HelpPopover = styled(HP) `
  position: relative;
  top: 2px;
`;
export const Label = styled.label `
  display: block;
  position: relative;
  ${typeStyle("bodyS")};
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth};` : "")};
  ${({ width }) => (width ? `width: ${width};` : "")};
  ${({ disabled }) => (disabled ? "opacity: 0.5; cursor: not-allowed;" : "")};
  ${variant("variant", {
    emphasized: css `
      color: ${color("typeHeader")};
      font-weight: bold;
    `,
    normal: css `
      color: ${color("typeMeta")};
    `
})};
`;
export const LabelWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  ${({ shouldVisuallyHideLabel }) => (shouldVisuallyHideLabel ? visuallyHidden() : "")}
`;
